import { render, staticRenderFns } from "./AboutUsOurStory.vue?vue&type=template&id=af2aea76"
import script from "./AboutUsOurStory.vue?vue&type=script&lang=ts"
export * from "./AboutUsOurStory.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports